import React from 'react';
import { Leaf, MapPin, FlaskConical } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: <FlaskConical className="w-5 h-5" data-id="element-142" />,
    text: 'Von Tierernährungs-Experten entwickelt'
  }, {
    icon: <Leaf className="w-5 h-5" data-id="element-143" />,
    text: 'Ohne künstliche Zusatzstoffe'
  }, {
    icon: <MapPin className="w-5 h-5" data-id="element-144" />,
    text: 'In Deutschland hergestellt'
  }];
  return <div className="bg-stone-100 border-y border-stone-200 py-6 px-4" data-id="element-145">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row flex-wrap justify-center items-center gap-x-8 gap-y-4" data-id="element-146">
        {items.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-stone-600 font-sans text-sm font-medium" data-id="element-147">
            <span className="text-brand-green" data-id="element-148">{item.icon}</span>
            <span data-id="element-149">{item.text}</span>
          </div>)}
      </div>
    </div>;
}